module.exports = __webpack_public_path__ + "img/image1.b7f0a2f8.jpg";